import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchContact, selectContact } from '@actions/contacts';
import Section from '@components/Section';
import Pill from '@components/Pill';
import styles from './Related.module.scss';

function NewRelatedContact({ contactID }) {
  const dispatch = useDispatch();
  const contact = useSelector(selectContact(contactID));
  const { isFetching, isPersisted } = contact;

  useEffect(() => {
    if (!isPersisted) {
      dispatch(fetchContact({ id: contactID }));
    }
  }, []);

  return isPersisted && !isFetching && !contact.error && <Pill contact={contact} clickable />;
}

export default function Related({ contacts, clickable = true }) {
  return (
    (contacts?.length || 0) > 0 && (
      <Section>
        <Section.Title underline>Related People</Section.Title>
        <div className={styles.pillContainer}>
          {contacts.map((contact) => (
            <React.Fragment key={contact.id}>
              {contact.displayName ? (
                <Pill contact={contact} clickable={clickable} />
              ) : (
                <NewRelatedContact contactID={contact.id} />
              )}
            </React.Fragment>
          ))}
        </div>
      </Section>
    )
  );
}
